module.exports = __webpack_public_path__ + "img/betc88Logo.1f166390.png";